import React from 'react';
import * as images from "../constant/imges";

const Global = () => {
    const globalOffices = [
        {
            region: "North America",
            image: 'https://img.freepik.com/free-photo/shanghai-cityscape-with-waibaidu-bridge_1359-1137.jpg?t=st=1746062126~exp=1746065726~hmac=121b7520c527475e523f3fb3d9d6d6e681229a9ddaf25bcfe1ed3a0d594bc9f5&w=740',
            alt: "North America",
            title: "Canada",
            subtitle: "Corporate Head Office:",
            address: "520 Caverhill Cres, Milton, Ontario, Canada, L9T5K2",
            contact: <a href="tel:+16472008668">+1 (647) 200-8668</a>
        },
        {
            region: "Europe",
            image: 'https://img.freepik.com/free-photo/tower-bridge-sunrise-london_268835-1391.jpg?t=st=1746062175~exp=1746065775~hmac=efc203f89cdee7c15f4defc1259ed77821681587826956e8fb5f3af530d9b3eb&w=740',
            alt: "Europe",
            title: "UK Representative Office",
            subtitle: "eSports LLC",
            address: "537 Norwood Road London, United Kingdom, SE27 OLE",
            contact: "Drew Patterson"
        },
        {
            region: "Middle East",
            image: 'https://img.freepik.com/free-photo/view-dubai-marina-sunrise-uae_268835-1056.jpg?t=st=1746062223~exp=1746065823~hmac=6c4412024bf1e1e6a9e748ddf30d44e81a243831fd97991e7c97107db984509a&w=740',
            alt: "Middle East", 
            title: "GCC Representative Office",
            subtitle: "Aamerah Group",
            address: "Office 104, Arcade Building - A1 Garhoud - Dubai - United Arab Emirates",
            contact: "Rashid A1 Ameri"
        },
        {
            region: "Africa",
            image: 'https://img.freepik.com/free-photo/surreal-geometric-shapes-barren-desert_23-2151296371.jpg?t=st=1746062352~exp=1746065952~hmac=a79f5fd38d4084c10e751098fe79265134bc17fc563f2e89328520a1e4cbfb28&w=740',
            alt: "Africa",
            title: "Nigeria Representative Office",
            subtitle: "INENTRIUM BUSINESS SUPPORT SERVICES (IBSS)",
            address: "8 Opebi Road. Ikeja, Lagos, Nigeria", 
            contact: "SOLA KEHINDE"
        },
        {
            region: "Asia",
            image: 'https://img.freepik.com/free-photo/los-angeles-night-with-urban-buildings-griffith-observatory_649448-104.jpg?t=st=1746062431~exp=1746066031~hmac=cbdcf8d4023781d3b7f1f9093b2091a1824db5db700f3911a69c52921ea8255a&w=740',
            alt: "Asia",
            title: "Pakistan Representative Office",
            subtitle: "Erada Consulting",
            address: "332, Raya, DHA Phase 6, Lahore, Pakistan",
            contact: "Khawaja Zubair Ahmed"
        }
    ];

    return (
        <div className="container py-5">
            <h1 className="text-center mb-5">Our Global Network</h1>
            <div className="row g-4">
                {globalOffices.map((office, index) => (
                    <div className="col-md-6" key={index}>
                        <div className="card h-100 shadow-sm w-100">
                            <div className="row w-100">
                                <div className="col-md-4" style={{ height: '200px' }}>
                                    <img src={office.image} className="img-fluid rounded-start h-100 w-100 object-fit-cover" alt={office.alt} />
                                </div>
                                <div className="col-md-8">
                                    <div className="card-body">
                                        <h5 className="card-title mb-4">{office.region}</h5>
                                        <p className="card-text">
                                            <strong>{office.title}</strong><br />
                                            {office.subtitle && <>{office.subtitle}<br /></>}
                                            {office.address && <>{office.address}<br /></>}
                                            {office.contact}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Global;